import { useApp } from './app-context'
import { ChannelGrid } from './program-grid-components/channel-grid'
import { ProgramGridHeader } from './program-grid-components/program-grid-header'
import { Timeline } from './program-grid-components/timeline'
import { ViewControls } from './program-grid-components/view-controls'

export const ProgramGrid = () => {
  const timelineInterval = Number(import.meta.env.VITE_TIMELINE_INTERVAL) || 30
  const { days } = useApp()
  const daysInterval = days.length > 0 ? days.length : 0

  return (
    <div className="tv-guide-inner">
      <ProgramGridHeader />
      <ViewControls totalDays={daysInterval}>
        <Timeline timelineInterval={timelineInterval} />
        <ChannelGrid />
      </ViewControls>
    </div>
  )
}
